import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModulesListComponent } from './modules-list/modules-list.component';
import { ModulesCreateComponent } from './modules-create/modules-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: ModulesListComponent,
        data: {
          title: "Modules List",
          breadcrumb: "Modules List"
        }
      },
      {
        path: 'create',
        component: ModulesCreateComponent,
        data: {
          title: "Create Modules",
          breadcrumb: "Create Modules"
        }
      },
      {
        path: 'edit/:id',
        component: ModulesCreateComponent,
        data: {
          title: "Edit Modules",
          breadcrumb: "Edit Modules"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ModulesRoutingModule { }
